import { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { ArrowRight, Loader2, CheckCircle2 } from "lucide-react";
import { API } from "../lib/api";
import { Input } from "./ui/input";
import { OPTIN } from "../constants/testIds";
import { toast } from "./ui/sonner";

export const EmailOptInForm = ({ source = "homepage", compact = false, className = "" }) => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [status, setStatus] = useState("idle");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus("loading");
    try {
      const res = await axios.post(`${API}/subscribe`, { email, name, source });
      setStatus("success");
      toast.success(res.data.message || "Check your inbox for the Prompts Library!");
    } catch (err) {
      setStatus("idle");
      toast.error(err?.response?.data?.detail || "Something went wrong. Please try again.");
    }
  };

  if (status === "success") {
    return (
      <div className={`flex items-center gap-2 text-gold font-mono-tag text-sm ${className}`} data-testid="optin-success-message">
        <CheckCircle2 className="w-5 h-5" aria-hidden="true" />
        You're in! Check your inbox for the Prompts Library.
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className={`flex flex-col ${compact ? "" : "sm:flex-row"} gap-3 w-full ${className}`}>
      {!compact && (
        <Input
          type="text"
          placeholder="First name (optional)"
          value={name}
          onChange={(e) => setName(e.target.value)}
          data-testid={OPTIN.nameInput}
          className="bg-surface/60 border-white/10 h-12 rounded-sm text-white placeholder:text-zinc-500 focus-visible:ring-2 focus-visible:ring-primary sm:max-w-[180px]"
        />
      )}
      <Input
        type="email"
        required
        placeholder="you@email.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        data-testid={OPTIN.emailInput}
        className="bg-surface/60 border-white/10 h-12 rounded-sm text-white placeholder:text-zinc-500 focus-visible:ring-2 focus-visible:ring-primary flex-1"
      />
      <motion.button
        type="submit"
        disabled={status === "loading"}
        data-testid={OPTIN.submitButton}
        whileHover={{ y: -2 }}
        whileTap={{ scale: 0.97 }}
        className="h-12 px-6 bg-primary hover:bg-[#5C7CFA] text-white font-medium text-sm rounded-sm inline-flex items-center justify-center gap-2 whitespace-nowrap transition-colors shadow-[0_0_0_1px_rgba(67,97,238,0.4)] disabled:opacity-60 w-full sm:w-auto"
      >
        {status === "loading" ? <Loader2 className="w-4 h-4 animate-spin" aria-hidden="true" /> : <>Get Free Prompts Library <ArrowRight className="w-4 h-4" aria-hidden="true" /></>}
      </motion.button>
    </form>
  );
};
